import { combineReducers } from "redux";

import settings from "./settings";
import search from "./search";
import player from "./player";
import system from "./system";
import relevantSearch from "./relevantSearch";
import mainTree from "./mainTree";
import shop from "./shop";
import support from "./support";
import paragraphsReducer from "./paragraphsReducer";
import sw from "./sw.reducer";
import toc from "./toc";
import library from "./library";
import featuredSearch from "@/shared/store/featuredSearch/reducer";
import share from "./share";

import { KEY_REDUCER_PARAGRAPHS } from "@/shared/store/paragraphs/constants";
import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";
import { KEY_REDUCER_PLAYER } from "@/shared/store/player/constants";
import { KEY_REDUCER_TOC } from "@/shared/store/toc/constants";
import { KEY_REDUCER_SYSTEM } from "@/shared/store/system/constants";
import { KEY_REDUCER_FEATURED_SEARCH } from "@/shared/store/featuredSearch/constants";
import { KEY_REDUCER_SHOP } from "@/shared/store/shop/constants";
import { KEY_REDUCER_SEARCH } from "@/shared/store/search/constants";
import { KEY_REDUCER_MAIN_TREE } from "@/shared/store/mainTree/constants";
import { KEY_REDUCER_SETTINGS } from "@/shared/store/settings/constants";
import { KEY_REDUCER_LIBRARY } from "@/shared/store/library/constants";
import { KEY_REDUCER_SHARE } from "@/shared/store/share/constants";

export default combineReducers({
  relevantSearch,
  support,
  [KEY_REDUCER_SHARE]: share,
  [KEY_REDUCER_SHOP]: shop,
  [KEY_REDUCER_SETTINGS]: settings,
  [KEY_REDUCER_MAIN_TREE]: mainTree,
  [KEY_REDUCER_SEARCH]: search,
  [KEY_REDUCER_FEATURED_SEARCH]: featuredSearch,
  [KEY_REDUCER_PLAYER]: player,
  [KEY_REDUCER_SYSTEM]: system,
  [KEY_REDUCER_PARAGRAPHS]: paragraphsReducer,
  [KEY_REDUCER_SW]: sw,
  [KEY_REDUCER_LIBRARY]: library,
  [KEY_REDUCER_TOC]: toc,
});
